import { Injectable } from '@angular/core';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';

(pdfMake as any).vfs = pdfFonts.pdfMake.vfs;

@Injectable({
    providedIn: 'root'
})
export class CertificadoPdfService {
    constructor() { }

    gerarCertificado(dados: {
        base64Background: string;
        orientacao: 'portrait' | 'landscape';
        textoPadrao: string;
        nome: string;
        sessao: string;
        data: string;
    }) {
        const pageSize = 'A4';
        const pageOrientation = dados.orientacao;

        const larguraPt = dados.orientacao === 'portrait' ? 595 : 842;
        const alturaPt = dados.orientacao === 'portrait' ? 842 : 595;

        const textoFinal = this.gerarTextoComVariaveis(
            dados.textoPadrao,
            dados.nome,
            dados.sessao,
            dados.data
        );

        const docDefinition: any = {
            pageSize,
            pageOrientation,
            pageMargins: [0, 0, 0, 0],
            background: [
                {
                    image: dados.base64Background,
                    width: larguraPt,
                    height: alturaPt
                }
            ],
            content: [
                {
                    text: 'Certificado de Participação',
                    fontSize: 28,
                    bold: true,
                    alignment: 'center',
                    margin: [0, alturaPt * 0.2, 0, 20]
                },
                {
                    text: textoFinal,
                    fontSize: 16,
                    alignment: 'center',
                    margin: [40, alturaPt * 0.2, 40, 0]
                }
            ]
        };

        pdfMake.createPdf(docDefinition).open();
    }

    /**
    * Substitui marcadores por valores reais
    */
    private gerarTextoComVariaveis(template: string, nome: string, sessao: string, data: string): string {
        return template
            .replace('{nome}', nome)
            .replace('{sessao}', sessao)
            .replace('{data}', data);
    }


    /**
     * MOCK - Método para testes com imagem do assets
     */
    async gerarCertificadoComImagemDeTeste(
        caminhoImagem: string,
        orientacao: 'portrait' | 'landscape',
        textoPadrao: string,
        nome: string,
        sessao: string,
        data: string
    ) {
        const extensao = this.obterExtensao(caminhoImagem);

        if (['png', 'jpg', 'jpeg'].includes(extensao)) {
            const base64 = await this.carregarImagemBase64(caminhoImagem);
            this.gerarCertificado({
                base64Background: base64,
                orientacao,
                textoPadrao,
                nome,
                sessao,
                data
            });
        } else {
            alert('Formato de imagem não suportado.');
        }
    }

    private obterExtensao(path: string): string {
        return path.split('.').pop()?.toLowerCase() || '';
    }

    private carregarImagemBase64(url: string): Promise<string> {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.crossOrigin = 'anonymous';
            img.src = url;

            img.onload = () => {
                const canvas = document.createElement('canvas');
                canvas.width = img.width;
                canvas.height = img.height;

                const ctx = canvas.getContext('2d');
                if (!ctx) return reject('Erro ao obter contexto do canvas');

                ctx.drawImage(img, 0, 0);
                const dataURL = canvas.toDataURL('image/png');
                resolve(dataURL);
            };

            img.onerror = () => reject('Erro ao carregar imagem');
        });
    }
    /*
    *   MOCK - FIM 
    */
}
